/* RESPONSIBLE TEAM: team-standalone */

import { OnboardingGuideStepData } from '../definitions';
import type ZendeskPlatform from '../../zendesk';

export default class ZendeskOnboardingGuideStep extends OnboardingGuideStepData {
  protected platform: ZendeskPlatform;

  constructor(platform: ZendeskPlatform) {
    super(platform);
    this.platform = platform;
  }

  override titleKey(stepIdentifier: string): string {
    if (this.platformIsDependent(stepIdentifier)) {
      return `onboarding.getting-started.steps.${stepIdentifier}.zendesk.title`;
    }
    return `onboarding.getting-started.steps.${stepIdentifier}.title`;
  }

  override descriptionKey(stepIdentifier: string): string {
    if (this.platformIsDependent(stepIdentifier)) {
      return `onboarding.getting-started.steps.${stepIdentifier}.zendesk.description`;
    }
    return `onboarding.getting-started.steps.${stepIdentifier}.description`;
  }

  override ctaKey(stepIdentifier: string): string {
    if (this.platformIsDependent(stepIdentifier)) {
      return `onboarding.getting-started.steps.${stepIdentifier}.zendesk.cta`;
    }
    return `onboarding.getting-started.steps.${stepIdentifier}.cta`;
  }

  override secondaryCTAKey(stepIdentifier: string): string {
    return `onboarding.getting-started.steps.${stepIdentifier}.secondary-cta`;
  }

  override get platformName() {
    return this.platform.intl.t('onboarding.getting-started.platforms.zendesk.name');
  }

  override moreInfoLinkLabel(stepIdentifier: string): string | null {
    if (stepIdentifier === 'fin_sa_onboarding_add_support_content') {
      return this.platform.intl.t(
        'onboarding.getting-started.platforms.zendesk.article-sync-zendesk',
      );
    }
    if (stepIdentifier === 'fin_sa_onboarding_connect_channels_and_turn_fin_live') {
      return this.platform.intl.t(
        'onboarding.getting-started.platforms.zendesk.how-fin-integrates-zendesk',
      );
    }
    return null;
  }

  override moreInfoArticleId(stepIdentifier: string): number | undefined {
    if (stepIdentifier === 'fin_sa_onboarding_add_support_content') {
      return 10617194;
    }
    if (stepIdentifier === 'fin_sa_onboarding_connect_channels_and_turn_fin_live') {
      return 10602087;
    }
    return undefined;
  }

  override shouldShowConnectDrawer(stepIdentifier: string): boolean {
    return stepIdentifier === 'fin_sa_onboarding_add_integration';
  }

  private platformIsDependent(stepIdentifier: string): boolean {
    return (
      stepIdentifier === 'fin_sa_onboarding_add_integration' ||
      stepIdentifier === 'fin_sa_onboarding_connect_channels_and_turn_fin_live'
    );
  }
}
